"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ToolsDate_1 = __importDefault(require("./Tools/ToolsDate"));
class MainSetup {
    static get isDevEnvironment() {
        return this.serverUrl.includes("localhost") || this.serverUrl.includes("127.0.0.1");
    }
    static get currentUserOrNull() {
        const rawCurrentUser = sessionStorage.getItem("Current User");
        if (!rawCurrentUser || rawCurrentUser === "null" || rawCurrentUser === "undefined") {
            return null;
        }
        try {
            const parsedUser = JSON.parse(rawCurrentUser);
            if (!parsedUser) {
                return null;
            }
            if (!parsedUser.systemRoleName || !parsedUser.userName) {
                return null;
            }
            return parsedUser;
        }
        catch {
            return null;
        }
    }
    static get currentUser() {
        const currentUser = this.currentUserOrNull;
        if (!currentUser) {
            throw new Error("Current user is not available yet");
        }
        return currentUser;
    }
    static set currentUser(data) {
        sessionStorage.setItem("Current User", JSON.stringify(data));
    }
    static getCurrentUserAsPerson() {
        const currentUser = this.currentUser;
        return this.personsEnviRepository.items.find((p) => `${p.name} ${p.surname}` === currentUser.userName);
    }
    static get currentProject() {
        return JSON.parse(sessionStorage.getItem("Projects repository")).currentItems[0];
    }
    static get currentContract() {
        return JSON.parse(sessionStorage.getItem("Contracts repository")).currentItems[0];
    }
    /** Czy rola należy do zakresowych (przypisania projektów, węższe menu). */
    static isProjectScopedRoleId(systemRoleId) {
        return this.PROJECT_SCOPED_ROLES.some((role) => MainSetup.SystemRoles[role].id === Number(systemRoleId));
    }
    static canViewInvoices() {
        return this.isRoleAllowed(this.STAFF_ROLES);
    }
    static canViewOffers() {
        return this.isRoleAllowed(this.STAFF_ROLES);
    }
    static isRoleAllowed(roles) {
        const currentUser = this.currentUserOrNull;
        if (!currentUser) {
            return false;
        }
        return roles.includes(currentUser.systemRoleName);
    }
}
MainSetup.CLIENT_ID = "386403657277-9mh2cnqb9dneoh8lc6o2m339eemj24he.apps.googleusercontent.com"; //ENVI - nowy test
MainSetup.serverUrl = window.location.href.includes("localhost")
    ? "http://localhost:3000/"
    : "https://erp-envi.herokuapp.com/";
MainSetup.InvoiceStatuses = {
    FOR_LATER: "Na później",
    TO_DO: "Do zrobienia",
    DONE: "Zrobiona",
    SENT: "Wysłana",
    READY_FOR_KSEF: "Gotowa do wysłania KSeF",
    SENT_TO_KSEF: "Wysłana do KSeF",
    KSEF_ERROR: "Odrzucona przez KSeF",
    PAID: "Zapłacona",
    TO_CORRECT: "Do korekty",
    WITHDRAWN: "Wycofana",
    CORRECTED: "Skorygowana",
};
MainSetup.ProjectStatuses = {
    NOT_STARTED: "Nie rozpoczęty",
    IN_PROGRESS: "W trakcie",
    FINISHED: "Zakończony",
};
MainSetup.ContractStatuses = {
    NOT_STARTED: "Nie rozpoczęty",
    IN_PROGRESS: "W trakcie",
    FINISHED: "Zakończony",
    ARCHIVAL: "Archiwalny",
};
MainSetup.SecurityStatus = {
    NOT_ISSUED: "Nie wydana",
    ISSUED: "Wydana",
    TO_PROLONG: "Do przedłużenia",
    PROLONGED: "Przedłużona",
    RETURNED_1ST_PART: "Zwrócona 70%",
    RETURNED_2ND_PART: "Zwrócona 100%",
};
MainSetup.MilestoneStatus = {
    NOT_STARTED: "Nie rozpoczęty",
    IN_PROGRESS: "W trakcie",
    FINISHED: "Zakończony",
    ARCHIVAL: "Archiwalny",
};
MainSetup.CaseStatus = {
    FOR_LATER: "Na zaś",
    IN_PROGRESS: "W trakcie",
    CLOSED: "Zamknięta",
};
MainSetup.TaskStatus = {
    BACKLOG: "Backlog",
    NOT_STARTED: "Nie rozpoczęty",
    IN_PROGRESS: "W trakcie",
    TO_CORRECT: "Do poprawy",
    AWAITING_RESPONSE: "Oczekiwanie na odpowiedź",
    DONE: "Zrobione",
};
MainSetup.OfferStatus = {
    DECISION_PENDING: "Składamy czy nie?",
    TO_DO: "Do złożenia",
    DONE: "Czekamy na wynik",
    AWARDED: "Wygrana",
    LOST: "Przegrana",
    WITHDRAWN: "Wycofana",
    CANCELED: "Unieważnione",
    NOT_INTERESTED: "Nie składamy",
};
MainSetup.ClientNeedStatus = {
    URGENT: "Pilne",
    IMPORTANT: "Ważne",
    NICE_TO_HAVE: "Miło by było",
    FOR_LATER: "Na później",
    NOT_ACTUAL: "Nie aktualne",
};
MainSetup.ApplicationCallStatus = {
    UNKOWN: "Nieznany",
    SCHEDULED: "Zaplanowany",
    OPEN: "Otwarty",
    CLOSED: "Zamknięty",
};
MainSetup.ElementsNeededForApplication = {
    EIA_DECISION: "DUŚ",
    PFU: "PFU",
    BUILDING_PERMIT: "Pozwolenie na budowę",
    DECISION: "Decyzja lokalizacyjna",
    MPZPT: "MPZPT",
};
MainSetup.OfferBidProcedure = {
    REQUEST_FOR_QUOTATION: "Zapytanie ofertowe",
    TENDER_PL: "Przetarg BZP",
    TENDER_EU: "Przetarg DUUE",
};
MainSetup.OfferForm = {
    EMAIL: "Email",
    PLATFORM: "Platforma",
    PAPER: "Papier",
};
MainSetup.OfferBondStatus = {
    NEW: "Jeszcze nie płacić",
    TO_PAY: "Do zapłacenia",
    PAID: "Zapłacone",
    TO_RENEW: "Do przedłużenia",
    DONE: "Złożone",
    TO_BE_RETURNED: "Do zwrotu",
    RETURNED: "Zwrócone",
};
MainSetup.OfferInvitationMailStatus = {
    NEW: "Nowy",
    TO_OFFER: "Przekazać do ofertowania",
    DONE: "Oferta utworzona",
    REJECTED: "Odrzucony",
};
MainSetup.OfferBondForm = {
    CASH: "Gotówka",
    GUARANTEE: "Gwarancja",
};
MainSetup.OfferEventType = {
    CREATED: "Oferta Utworzona",
    SEND: "Oferta wysłana",
    CHANGED: "Oferta zmieniona",
    AWARDED: "Oferta wygrana",
    LOST: "Oferta przegrana",
    CANCELED: "Przetarg unieważniony",
    WITHDRAWN: "Oferta wycofana",
};
MainSetup.OurLetterStatus = {
    CREATED: "Utworzony",
    TO_CORRECT: "Do poprawy",
    CHANGED: "Zmieniony",
    APPROVED: "Zatwierdzony",
    SENT: "Wysłany",
};
MainSetup.IncomingLetterStatus = {
    REGISTERED: "Zarejestrowany",
    RESPONSE_SENT: "Odpowiedź wysłana", // bardziej naturalna forma
    RESPONSE_REQUIRED: "Wymaga odpowiedzi", // krócej i konkretniej
    NO_RESPONSE_REQUIRED: "Nie wymaga odpowiedzi", // bardziej jednoznaczne
};
/**
 * GPO-3 — stany porównania podmiotu z rejestrem GUS.
 *
 * Inaczej niż pozostałe słowniki stanów w tym pliku: baza trzyma tu KLUCZ
 * (`DIFF_MINOR`), a nie napis po polsku. Napisy są nazwami zatwierdzonymi przez
 * właściciela 2026-09-09 przy makiecie — plakietka na liście podmiotów i filtr
 * biorą je stąd, żeby nie rozjechały się na dwa brzmienia.
 */
MainSetup.GusStatus = {
    DIFF: "różni się",
    DIFF_MINOR: "inny zapis",
    OK: "zgodny",
    CLOSED: "wykreślony z rejestru",
    NOT_FOUND: "nieznany w rejestrze",
    ERROR: "błąd",
    NOT_CHECKED: "nie sprawdzano",
};
MainSetup.LetterEventType = {
    CREATED: "Utworzony",
    TO_CORRECT: "Do poprawy",
    CHANGED: "Zmieniony",
    APPROVED: "Zatwierdzony",
    SENT: "Wysłany",
    CANCELED: "Anulowany",
};
MainSetup.InvoicesFilterInitState = {
    ISSUE_DATE_FROM: ToolsDate_1.default.addDays(new Date(), -90).toISOString().slice(0, 10),
    ISSUE_DATE_TO: ToolsDate_1.default.addDays(new Date(), +10).toISOString().slice(0, 10),
};
MainSetup.CostInvoicesFilterInitState = {
    DATE_FROM: ToolsDate_1.default.addDays(new Date(), -60).toISOString().slice(0, 10),
    DATE_TO: ToolsDate_1.default.addDays(new Date(), 0).toISOString().slice(0, 10),
};
MainSetup.LettersFilterInitState = {
    CREATION_DATE_FROM: ToolsDate_1.default.addDays(new Date(), -90).toISOString().slice(0, 10),
    CREATION_DATE_TO: ToolsDate_1.default.addDays(new Date(), +5).toISOString().slice(0, 10),
};
MainSetup.ContractsFilterInitState = {
    START_DATE_FROM: ToolsDate_1.default.addDays(new Date(), -365).toISOString().slice(0, 10),
    START_DATE_TO: ToolsDate_1.default.addDays(new Date(), +600).toISOString().slice(0, 10),
    END_DATE_FROM: ToolsDate_1.default.addDays(new Date(), -60).toISOString().slice(0, 10),
};
MainSetup.SecuritiesFilterInitState = {
    START_DATE_FROM: ToolsDate_1.default.addDays(new Date(), -365).toISOString().slice(0, 10),
    START_DATE_TO: ToolsDate_1.default.addDays(new Date(), +600).toISOString().slice(0, 10),
    FIRST_PART_EXPIRY_DATE_FROM: ToolsDate_1.default.addDays(new Date(), -60).toISOString().slice(0, 10),
    SECOND_PART_EXPIRY_DATE_FROM: ToolsDate_1.default.addDays(new Date(), -60).toISOString().slice(0, 10),
};
MainSetup.OffersFilterInitState = {
    SUBMISSION_FROM: ToolsDate_1.default.addDays(new Date(), -180).toISOString().slice(0, 10),
    SUBMISSION_TO: ToolsDate_1.default.addDays(new Date(), +40).toISOString().slice(0, 10),
    STATUSES: [MainSetup.OfferStatus.TO_DO, MainSetup.OfferStatus.DECISION_PENDING, MainSetup.OfferStatus.DONE],
};
MainSetup.MilestoneDatesFilterInitState = {
    END_DATE_FROM: ToolsDate_1.default.addDays(new Date(), -365).toISOString().slice(0, 10),
    END_DATE_TO: ToolsDate_1.default.addDays(new Date(), +600).toISOString().slice(0, 10),
    STATUSES: [
        MainSetup.MilestoneStatus.NOT_STARTED,
        MainSetup.MilestoneStatus.IN_PROGRESS,
        MainSetup.MilestoneStatus.FINISHED,
    ],
};
MainSetup.OffersInvitationMailFilterInitState = {
    INCOMING_DATE_FROM: ToolsDate_1.default.addDays(new Date(), -7).toISOString().slice(0, 10),
    INCOMING_DATE_TO: ToolsDate_1.default.addDays(new Date(), 0).toISOString().slice(0, 10),
};
MainSetup.SystemRoles = {
    ADMIN: {
        id: 1,
        systemName: "ADMIN",
        description: "Pełny dostęp do systemu",
    },
    ENVI_MANAGER: {
        id: 2,
        systemName: "ENVI_MANAGER",
        description: "Rozszerzone uprawnienia pracownika ENVI – zarządzanie projektami, zadaniami, ofertami i fakturami",
    },
    ENVI_EMPLOYEE: {
        id: 3,
        systemName: "ENVI_EMPLOYEE",
        description: "Pracownik ENVI – praca z projektami i zadaniami",
    },
    ENVI_COOPERATOR: {
        id: 4,
        systemName: "ENVI_COOPERATOR",
        description: "Współpracownik zewnętrzny – dostęp tylko do pism",
    },
    EXTERNAL_USER: {
        id: 5,
        systemName: "EXTERNAL_USER",
        description: "Użytkownik zewnętrzny – domyślnie osoba bez dostępu do wirtyny, po dodaniu maila systemowego dostęp tylko do pism",
    },
    CONTRACT_WORKER: {
        id: 6,
        systemName: "CONTRACT_WORKER",
        description: "Pracownik kontraktowy – praca operacyjna wyłącznie w przypisanych projektach, bez faktur, ofert i dotacji",
    },
    CLIENT: {
        id: 7,
        systemName: "CLIENT",
        description: "Klient – zakres pracownika kontraktowego (tylko przypisane projekty) plus raporty z wizyt na budowie",
    },
};
/** Pracownicy ENVI – pełny zakres modułów firmowych. */
MainSetup.STAFF_ROLES = [
    "ADMIN",
    "ENVI_MANAGER",
    "ENVI_EMPLOYEE",
];
/**
 * Panel administracyjny – słowniki i uprawnienia. Węższy niż STAFF_ROLES,
 * bo ten wykaz obejmuje też ENVI_EMPLOYEE.
 *
 * Musi odpowiadać ADMIN_PANEL_ROLES po stronie backendu (src/Admin/adminPanelGuard.ts).
 * Rozjechanie się obu list daje albo pozycję w menu prowadzącą w 403, albo
 * funkcję ukrytą w menu, ale dostępną po wpisaniu adresu. Backend rozstrzyga.
 */
MainSetup.ADMIN_PANEL_ROLES = ["ADMIN", "ENVI_MANAGER"];
/** Role, którym backend zawęża dane do projektów przypisanych w PersonProjects.
 * Tym rolom wskazuje się projekty w modalu użytkownika. */
MainSetup.PROJECT_SCOPED_ROLES = ["CONTRACT_WORKER", "CLIENT"];
/** Role widzące kontrakty – pracownicy ENVI oraz role zakresowe
 * (tym ostatnim backend zawęża dane do przypisanych projektów). */
MainSetup.CONTRACT_SCOPED_ROLES = [
    ...MainSetup.STAFF_ROLES,
    ...MainSetup.PROJECT_SCOPED_ROLES,
];
/** Role z przeglądem cudzych wizyt na budowie – pracownicy ENVI oraz klient
 * (klientowi backend zawęża wizyty do przypisanych projektów). */
MainSetup.VISITS_OVERVIEW_ROLES = [...MainSetup.STAFF_ROLES, "CLIENT"];
MainSetup.RoleGroups = {
    EMPLOYER: "Zamawiający",
    ENGINEER: "Inżynier",
    CONTRACTOR: "Wykonawca/Podwykonawcy",
    OTHERS: "Pozostali",
};
exports.default = MainSetup;
